/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PhrShareSettingTypename = "PhrShareSetting" as const;

/**
 *
 * @export
 * @interface PhrShareSetting
 */
export interface PhrShareSetting {
  /**
   *
   * @type {boolean}
   * @memberof PhrShareSetting
   */
  enableShare?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof PhrShareSetting
   */
  types?: Array<PhrShareSettingTypesEnum>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrShareSetting
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PhrShareSettingTypesEnum {
  Medication = "medication",
  SpecificHealthCheckup = "specific_health_checkup",
}

export function PhrShareSettingFromJSON(json: any): PhrShareSetting {
  return PhrShareSettingFromJSONTyped(json, false);
}

export function PhrShareSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrShareSetting {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrShareSettingTypename,

    enableShare: !exists(json, "enable_share") ? undefined : json["enable_share"],
    types: !exists(json, "types") ? undefined : json["types"],
  };
}

export function PhrShareSettingToJSON(object?: PhrShareSetting | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    enable_share: value.enableShare,
    types: value.types,
  };
}
